<template>
  <v-container>
    <v-row>
      <v-col cols="2" v-show="$vuetify.breakpoint.mdAndUp"></v-col>
      <v-col cols="12" md="8" class="mt-5">
        <h1 class="display-1 font-weight-black text-center mb-3">
          Pengajuan Kredit
        </h1>
        <p>
          <i>Nasabah Yang Terhormat,</i>
          <br />
          Terima kasih atas kepercayaan Anda memilih <b>ITC Finance</b>.
          Fasilitas aplikasi ini tersedia untuk memudahkan Anda dalam mengajukan
          kredit/pinjaman secara online. Silahkan mengisi data-data yang tertera
          pada form di bawah ini dengan lengkap dan nantinya akan diproses oleh
          <b>ITC Finance</b>
        </p>
      </v-col>
      <v-col cols="2" v-show="$vuetify.breakpoint.mdAndUp"></v-col>

      <v-col cols="2" v-show="$vuetify.breakpoint.mdAndUp"></v-col>
      <v-col cols="12" md="8">
        <v-alert
          :type="!error ? 'success' : 'error'"
          ref="alert"
          dismissible
          v-show="submitted"
        >
          {{ msg }}
        </v-alert>
        <v-form v-model="valid" ref="refForm">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                color="amber darken-4"
                label="Nama Depan"
                outlined
                prepend-inner-icon="mdi-account"
                required
                :rules="nameRules"
                type="text"
                v-model="firstName"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                color="amber darken-4"
                label="Nama Belakang"
                outlined
                prepend-inner-icon="mdi-account"
                required
                :rules="nameRules"
                type="text"
                v-model="lastName"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                color="amber darken-4"
                label="Nomor KTP"
                outlined
                prepend-inner-icon="mdi-account-card-details"
                required
                :rules="ktpRules"
                type="text"
                v-model="ktp"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                color="amber darken-4"
                label="Nama Penjamin"
                outlined
                prepend-inner-icon="mdi-account"
                required
                :rules="nameRules"
                type="text"
                v-model="guarantorName"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                color="amber darken-4"
                label="Tempat Lahir (Sesuai KTP)"
                outlined
                prepend-inner-icon="mdi-map-marker"
                required
                :rules="nameRules"
                type="text"
                v-model="place"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                color="amber darken-4"
                label="Tanggal Lahir (Sesuai KTP ex: 17/08/1945)"
                outlined
                prepend-inner-icon="mdi-calendar-month"
                required
                :rules="birthdateRules"
                type="text"
                v-model="birthdate"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                color="amber darken-4"
                label="Alamat (Sesuai KTP)"
                outlined
                prepend-inner-icon="mdi-home-map-marker"
                required
                :rules="addressRules"
                type="text"
                v-model="addressKtp"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                color="amber darken-4"
                label="Alamat (Saat ini)"
                outlined
                prepend-inner-icon="mdi-home-map-marker"
                required
                :rules="addressRules"
                type="text"
                v-model="addressNow"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                color="amber darken-4"
                label="Nomor Telepon"
                outlined
                prepend-inner-icon="mdi-phone"
                required
                :rules="phoneRules"
                type="text"
                v-model="phone"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                color="amber darken-4"
                label="Email"
                outlined
                prepend-inner-icon="mdi-email"
                required
                :rules="emailRules"
                type="email"
                v-model="email"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                color="amber darken-4"
                label="Subyek"
                outlined
                prepend-inner-icon="mdi-text-subject"
                type="text"
                v-model="subject"
                :rules="subjectRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                color="amber amber-darken-4"
                label="Pesan"
                prepend-inner-icon="mdi-message-text-outline"
                required
                :rules="messageRules"
                v-model="message"
              ></v-textarea>
            </v-col>
            <v-col class="text-center">
              <v-btn
                color="amber amber-darken-4"
                :disabled="!valid"
                :loading="loading"
                @click="submit"
                class="text--white"
              >
                Kirim&nbsp;<v-icon>mdi-send</v-icon>
              </v-btn>

              <v-btn
                color="blue-grey lighten-2"
                @click="reset"
                class="text--white"
              >
                Reset&nbsp;<v-icon>mdi-reload</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
      <v-col cols="2" v-show="$vuetify.breakpoint.mdAndUp"></v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import {
  SERVER_ENDPOINT,
  EMAIL_APPLICATION_ENDPOINT,
  TRANSFORM_REQUEST,
} from "@/utils/constant";

export default {
  name: "CreditApplication",
  computed: {
    isNotEmptyForm() {
      return (
        this.firstName ||
        this.lastName ||
        this.guarantorName ||
        this.place ||
        this.ktp ||
        this.birthdate ||
        this.addressKtp ||
        this.addressNow ||
        this.phone ||
        this.email ||
        this.subject ||
        this.message
      );
    },
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      guarantorName: "",
      place: "",
      nameRules: [
        (v) => !!v || "Field ini tidak boleh kosong",
        (v) => /^[A-Za-z ]*$/.test(v) || "Isi field harus valid",
      ],
      ktp: "",
      ktpRules: [
        (v) => !!v || "Nomor KTP tidak boleh kosong",
        (v) => /^[\d]{16}$/.test(v) || "Nomor KTP harus valid",
      ],
      birthdate: "",
      birthdateRules: [
        (v) => !!v || "Tanggal lahir tidak boleh kosong",
        (v) =>
          /^(0?[1-9]|[12]\d|3[01])[.\/\\-](0?[1-9]|1[12])[.\/\\-](19|20)\d{2}$/.test(
            v
          ) || "Tanggal lahir harus valid",
      ],
      addressKtp: "",
      addressNow: "",
      addressRules: [(v) => !!v || "Alamat tidak boleh kosong"],
      phone: "",
      phoneRules: [
        (v) => !!v || "Telepon tidak boleh kosong",
        (v) =>
          /^(^\+62\s?|^0)(\d{3,4}-?){2}\d{3,4}$/.test(v) ||
          "Telepon harus valid",
      ],
      email: "",
      emailRules: [
        (v) => !!v || "Email tidak boleh kosong",
        (v) =>
          /^[\w\.\-]+@(?:[A-Za-z\-]+\.)+[A-Za-z]{2,}$/.test(v) ||
          "Email harus valid",
      ],
      subject: "",
      subjectRules: [(v) => !!v || "Subyek tidak boleh kosong"],
      message: "",
      messageRules: [(v) => !!v || "Pesan tidak boleh kosong"],
      valid: false,
      loading: false,
      submitted: false,
      error: false,
      msg: "",
    };
  },
  head() {
    return {
      title: `ITC Finance | Pengajuan Kredit`,
    };
  },
  methods: {
    async submit(e) {
      e.preventDefault();
      this.resetStatus();
      this.loading = true;

      const payload = {
        addressNow: this.addressNow,
        addressKtp: this.addressKtp,
        birthdate: this.birthdate,
        email: this.email,
        firstName: this.firstName,
        guarantorName: this.guarantorName,
        ktp: this.ktp,
        lastName: this.lastName,
        message: this.message,
        phone: this.phone,
        place: this.place,
        subject: this.subject,
      };

      try {
        const { data } = await axios.post(
          `${SERVER_ENDPOINT}${EMAIL_APPLICATION_ENDPOINT}`,
          payload,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            transformRequest: (jsonData) => TRANSFORM_REQUEST(jsonData),
          }
        );
        if (data.success) {
          this.error = false;
          this.msg = data.status;
        } else {
          this.error = true;
          throw new Error(data.status);
        }
        console.log(data.data);
      } catch (err) {
        this.error = true;
        this.msg = err;
      } finally {
        this.loading = false;
        this.submitted = true;
        this.reset();
      }
    },
    reset() {
      this.$refs.refForm.reset();
    },
    resetStatus() {
      this.submitted = false;
      this.error = false;
      this.msg = "";
    },
  },
};
</script>

<style></style>
